import Place from '@/models/place';
import placeApi from '@/api/place';
import { ActionContext, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { PlaceInit } from '@/interfaces/models/place';

type PlaceState = {
  places: Array<Place>;
  selectedPlace: Place | null
};

const getDefaultState = (): PlaceState => {
  return {
    places: [],
    selectedPlace: null
  };
};

const namespaced: boolean = true;

const state: PlaceState = getDefaultState();

const getters: GetterTree<PlaceState, RootState> = {
  todayTakeAwayTimetable(state, getters, rootState: any) {
    const dayOfWeek = rootState.timer.today.getEuropeanDay();

    if (state.selectedPlace) {
      return state.selectedPlace.isTakeAwayTBDefault
        ? state.selectedPlace.timetableTakeAway[dayOfWeek]
        : state.selectedPlace.timetable[dayOfWeek];
    }

    return [];
  }
};

const actions = {
  selectPlace({ commit, dispatch }: ActionContext<RootState, RootState>, place: Place) {
    dispatch('resetStore', null, { root: true });

    commit('selectPlace', place);
  },
  selectPlaceById({ commit, dispatch, state }: ActionContext<PlaceState, RootState>, placeId: string) {
    const place = state.places.find((place: Place) => place.id === placeId);

    dispatch('resetStore', null, { root: true });

    commit('selectPlace', place);
  },
  editPlace({ dispatch }: ActionContext<PlaceState, RootState>, { id, editedFields }: any) {
    placeApi.editPlace(editedFields);

    return dispatch('socketEditPlace', { id, ...editedFields }, { root: true });
  },
  editPlaceWidgetSettings({ dispatch }: ActionContext<PlaceState, RootState>, { id, widget }: any) {
    placeApi.editPlaceWidgetSettings(widget);

    return dispatch('socketEditPlace', { id, widget }, { root: true });
  },
  editPlaceDiscountSettings({ dispatch }: ActionContext<PlaceState, RootState>, { id, discountSettings }: any) {
    placeApi.editPlaceDiscountSettings(discountSettings);

    return dispatch('socketEditPlace', { id, discountSettings }, { root: true });
  },
};

const mutations: MutationTree<PlaceState> = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setPlaces(state, places: Array<PlaceInit>) {
    state.places = places.map((place) => new Place(place));
  },
  selectDefaultPlace(state) {
    state.selectedPlace = state.places.find(({ id }) => id === window.localStorage.getItem('placeId')) || state.places[0];
  },
  editPlace(state, newProps: any) {
    const editedPlace = state.places.find((place: Place) => place.id === newProps.id);

    if (editedPlace !== undefined) {
      editedPlace.mergeWithNewFields(newProps);
    }
  },
  setShowBlockedInformation(state, { id, blocked}: { id: string, blocked: boolean }) {
    const editedPlace = state.places.find((place: Place) => place.id === id);

    if (editedPlace !== undefined) {
      editedPlace.showBlockedInformation = blocked;
    }

    if (state.selectedPlace !== null) {
      state.selectedPlace.showBlockedInformation = blocked;
    }
  },
  setShowAlmostBlockedInformation(state, { id, showBlockedInformation}: { id: string, showBlockedInformation: boolean }) {
    const editedPlace = state.places.find((place: Place) => place.id === id);

    if (editedPlace !== undefined) {
      editedPlace.showAlmostBlockedInformation = showBlockedInformation;
    }

    if (state.selectedPlace !== null) {
      state.selectedPlace.showAlmostBlockedInformation = showBlockedInformation;
    }
  },
  selectPlace(state, place: Place) {
    window.localStorage.setItem('placeId', place.id);

    state.selectedPlace = place;
  },
  selectPlaceById(state, placeId: string) {
    window.localStorage.setItem('placeId', placeId);

    const place = state.places.find(({ id }) => id === placeId);

    if (place !== undefined) {
      state.selectedPlace = place;
    }
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
